import { ReactElement } from 'react';
import { IComponentJsonFields } from 'types/contentful';
import StateCityCta, { IStateCityCta } from './StateCityCta';

const getRenderComponent = (
  renderType: string,
  data: unknown,
  heading?: IComponentJsonFields['heading']
): ReactElement => {
  switch (renderType) {
    case 'State City CTA':
      return <StateCityCta data={data as IStateCityCta[]} heading={heading} />;
    default:
      return <></>;
  }
};

export default function JsonComponent({
  renderType,
  data,
  heading,
}: IComponentJsonFields): ReactElement {
  return getRenderComponent(renderType, data, heading);
}
